import { __assign } from "tslib";
// DS: C59
import React from 'react';
import { useTranslation } from 'react-i18next';
import DesktopSharePopup from './DesktopSharePopup';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle, getDeviationResourceType, } from '../../DeviationViews/_helpers';
var DesktopDeviationSharePopup = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement(DesktopSharePopup, __assign({ title: getTranslatedDeviationTitle(deviation, t), biData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
        } }, getDeviationShareCodes(deviation))));
};
DesktopDeviationSharePopup.displayName = 'DesktopDeviationSharePopup';
export default DesktopDeviationSharePopup;
//# sourceMappingURL=DesktopDeviationSharePopup.js.map